import { render, staticRenderFns } from "./support.vue?vue&type=template&id=d29da018&scoped=true"
import script from "./support.vue?vue&type=script&lang=js"
export * from "./support.vue?vue&type=script&lang=js"
import style0 from "./support.vue?vue&type=style&index=0&id=d29da018&prod&scoped=true&lang=css"
import style1 from "./support.vue?vue&type=style&index=1&id=d29da018&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29da018",
  null
  
)

export default component.exports